import {CAMPAIGN_KEYS} from "@/api/campaignApi";
import {client} from "@/httpClient";
import {i18n} from "@/i18n";
import {queryClient} from "@/queryClient";
import useCampaignInfluencerFilterStore from "@/store/campaignInfluencerFilter";
import {useMutation} from "@tanstack/react-query";

export const MEDIA_KEYS = {
  mContentReview: ["/content_review/"],
  mContentReviewTemplateDelete: ["/content_review/delete_template/"],
  mContentReviewTemplateList: ["/content_review/template/"],
  mInstagramCodeCopy: (contentId: number) => [`/instagram/${contentId}/copy_video_code/`],
  mInstagramMedia: (mediaId: number) => [`/instagram/${mediaId}/`],
  mMediaPurchase: ["/media_purchase/"],
  mMediaPurchaseBulk: ["/media_purchase/bulk/"],
  mMediaScraping: ["/harvest/scraping/"],
  mTikTokCodeCopy: (contentId: number) => [`/tiktok/${contentId}/copy_video_code/`],
  mTikTokMedia: (mediaId: string) => [`/tiktok/${mediaId}/`],
  mUgcMediaApprove: ["/ugc_media/approve/"],
  mUgcMediaRevision: ["/ugc_media/revision/"],
  qContentFeedback: ({campaignId}: {campaignId: number}) => [
    `/content_review/campaign_feedbacks/?campaign_id=${campaignId}`,
  ],
  qContentFeedbackTemplates: ["/content_review/template/"],
  qInstagramFeed: (influencerId: number, params?: string) => [
    `/harvest/instagram_feed/?influencer_id=${influencerId}&${params}`,
  ],
  qTikTokFeed: (influencerId: number, params?: string) => [
    `/harvest/tiktok_feed/?influencer_id=${influencerId}&${params}`,
  ],
} as const;

export const useScrapeStatistic = (campaignId: number, mediaId?: number) => {
  const searchParam = useCampaignInfluencerFilterStore(state => state.filters.search);

  return useMutation({
    meta: {errorMessage: i18n.t("campaign_overview:campaign_scrape_error")},
    mutationKey: MEDIA_KEYS.mMediaScraping,
    mutationFn: () =>
      client.post(MEDIA_KEYS.mMediaScraping[0], {
        campaign_id: campaignId,
        media_ids: !!mediaId ? [mediaId] : undefined,
      }),
    onSuccess: () => {
      [
        CAMPAIGN_KEYS.qCampaignManagement(campaignId),
        CAMPAIGN_KEYS.qCampaignManagementStats(campaignId),
        CAMPAIGN_KEYS.qCampaignReporting({campaignId}),
        CAMPAIGN_KEYS.qCampaignReportingApplications({campaignId, searchParam}),
      ].map(queryKey => queryClient.invalidateQueries({queryKey}));
    },
  });
};
